import type { Cache } from '@urql/exchange-graphcache';
import type { graphql } from '@/gql/graphql';
import useAuthStore from '@/stores/useAuthStore';
import DeleteMessageReactionByPkOptimisticFragment from './delete_message_reaction_by_pk/DeleteMessageReactionByPkOptimisticFragment';
import getDeletedReactionCount from './delete_message_reaction_by_pk/getDeletedReactionCount';

export default function delete_message_reaction_by_pk(
  args: {
    id: ReturnType<typeof graphql.scalar<'uuid'>>;
  },
  cache: Cache,
) {
  const reactionId = args.id;

  if (!reactionId) {
    return null;
  }

  const personId = useAuthStore.getState().uid;

  const reaction = cache.readFragment(
    DeleteMessageReactionByPkOptimisticFragment,
    {
      __typename: 'message_reaction',
      id: reactionId,
    },
    {
      personId,
    },
  );

  if (!reaction) {
    return null;
  }

  const nextCount = getDeletedReactionCount(
    reaction.content,
    reaction.message.reaction_count || [],
  );

  return {
    __typename: 'message_reaction',
    id: reactionId,
    message: {
      __typename: 'message',
      id: reaction.message.id,
      reaction_count: nextCount,
      your_reactions: reaction.message.your_reactions?.filter(
        (reaction) => reaction.id !== reactionId,
      ),
    },
  };
}
